import React from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import FlatSaleStage from '../../../pages/HousePage/tabs/Flat/components/FlatSaleStage';
import TitleCard from './TitleCard';
import useFlatsGridState from '../../../hooks/useFlatsGridState';
import { useSaleQuery } from '../../../hooks/useSaleAddressQuery';
import { ModalStateProvider } from './services/modalState';
import LifeCycleCard from './components/LifeCycleCard';
import ChangeStageModal from './components/ChangeStageModal';
import { texts } from '../../../constants/texts';
import ChangeStepModal from './components/ChangeStepModal';
import LifeCycleChangeBtn from './components/LifeCycleChangeBtn';
import styles from './RoomStage.module.scss';

const selectCurrentFlat = (state) => state.housingStockStore.currentFlat;

const RoomStage = ({ className, title, darkTheme = true, openForm }) => {
  const { flatsGridState, flatsGridQueryKey } = useFlatsGridState();

  const currentFlat = useSelector(selectCurrentFlat);

  return (
    <Spin
      spinning={
        flatsGridQueryKey?.[0] === undefined || flatsGridState?.isFetching
      }
    >
      <InfoCard
        title={<TitleCard title={title} openForm={openForm} />}
        className={className}
        dark={darkTheme}
      >
        <ul className={styles.metersList}>
          <li>
            <StageBlock room={currentFlat} flatsGridKey={flatsGridQueryKey} />
          </li>
          <li>
            <StepBlock room={currentFlat} flatsGridKey={flatsGridQueryKey} />
          </li>
          <li>
            <AcceptanceStatusBlock room={currentFlat} />
          </li>
          <li>
            <SaleBlock flatsGridKey={flatsGridQueryKey} />
          </li>
        </ul>
      </InfoCard>
    </Spin>
  );
};

export default RoomStage;

function StageBlock({ room, flatsGridKey }) {
  return (
    <ModalStateProvider>
      <LifeCycleCard
        title={texts.premisesStage}
        name={room?.addressLifeCycle?.stageAddressLifeCycle?.name ?? '-'}
        action={<LifeCycleChangeBtn />}
      />
      <ChangeStageModal room={room} flatsGridKey={flatsGridKey} />
    </ModalStateProvider>
  );
}

function StepBlock({ room, flatsGridKey }) {
  return (
    <ModalStateProvider>
      <LifeCycleCard
        title={texts.stepStage}
        name={room?.addressLifeCycle?.stepAddressLifeCycle?.name ?? '-'}
        action={<LifeCycleChangeBtn />}
      />
      <ChangeStepModal room={room} flatsGridKey={flatsGridKey} />
    </ModalStateProvider>
  );
}

function AcceptanceStatusBlock({ room }) {
  return (
    <LifeCycleCard
      title={texts.acceptanceStage}
      name={
        room?.addressLifeCycle?.acceptanceStatusAddressLifeCycle?.name ?? '-'
      }
    />
  );
}

function SaleBlock({ flatsGridKey }) {
  const { data: sale, isFetching } = useSaleQuery({
    staleTime: Infinity,
    select: (data) => data?.salesAddressLifeCycle,
  });

  return (
    <Spin spinning={isFetching}>
      <FlatSaleStage sale={sale} flatsGridQueryKey={flatsGridKey} />
    </Spin>
  );
}
